import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Card, Badge, EmptyState, fmtDate, Select } from "@/components/ui-kit";
import { ScrollText } from "lucide-react";

export default function AuditLog() {
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState({ entity: "" });
  const load = async () => {
    const params = {};
    if (filter.entity) params.entity = filter.entity;
    const { data } = await api.get("/audit-log", { params });
    setList(data);
  };
  useEffect(() => { load(); }, [filter]);

  const actionColor = (a) => a?.includes("delete") ? "red" : a?.includes("update") ? "amber" : a?.includes("create") ? "green" : "slate";

  return (
    <div data-testid="audit-log-page">
      <PageHeader title="Audit Log" subtitle="System activity history"/>
      <Card className="p-4 mb-4">
        <div className="flex gap-3">
          <Select value={filter.entity} onChange={(e) => setFilter({...filter, entity: e.target.value})}>
            <option value="">All entities</option>
            <option value="doctors">Doctors</option>
            <option value="pharmacies">Pharmacies</option>
            <option value="order">Orders</option>
            <option value="products">Products</option>
            <option value="users">Users</option>
          </Select>
        </div>
      </Card>
      <Card>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-slate-50 border-y text-xs uppercase tracking-wider text-slate-500">
                <th className="py-2 px-3 text-start">Date</th>
                <th className="py-2 px-3 text-start">User</th>
                <th className="py-2 px-3 text-start">Role</th>
                <th className="py-2 px-3 text-start">Action</th>
                <th className="py-2 px-3 text-start">Entity</th>
                <th className="py-2 px-3 text-start">Entity ID</th>
                <th className="py-2 px-3 text-start">Details</th>
              </tr>
            </thead>
            <tbody>
              {list.map(l => (
                <tr key={l.id} className="border-b border-slate-100">
                  <td className="py-2 px-3 text-xs">{fmtDate(l.created_at)} {new Date(l.created_at).toLocaleTimeString()}</td>
                  <td className="py-2 px-3 font-semibold">{l.user_name}</td>
                  <td className="py-2 px-3"><Badge color="slate">{l.user_role}</Badge></td>
                  <td className="py-2 px-3"><Badge color={actionColor(l.action)}>{l.action}</Badge></td>
                  <td className="py-2 px-3">{l.entity}</td>
                  <td className="py-2 px-3 font-mono text-xs text-slate-500">{(l.entity_id || "").slice(0, 8) || "-"}</td>
                  <td className="py-2 px-3 text-xs text-slate-600 font-mono max-w-md truncate">{JSON.stringify(l.details || {})}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {list.length === 0 && <EmptyState message="No audit entries yet"/>}
        </div>
      </Card>
    </div>
  );
}
